import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { OptionVariationData } from '../../../../../data/model';
import Icon from '../../../../../shared/components/Icon/Icon';
import ColorFacetFilterState from '../../FabricFacetFiltersDropdowns/ColorFacetFilter/ColorFacetFilterState';
import css from './ColorFacetFilter.css';

interface ColorFacetFilterProps {
  state: ColorFacetFilterState;
  allItems: Array<OptionVariationData>;
}

const ColorFacetFilter = ({ state, allItems }: ColorFacetFilterProps) => {
  if (state.availableProperties.length === 0) {
    return null;
  }

  return (
    <div className={css.items}>
      {state.availableProperties.map((item) => (
        <Option item={item} allItems={allItems} key={item.data.valueId} />
      ))}
    </div>
  );
};

export default observer(ColorFacetFilter);

type ColorOptionItem = ColorFacetFilterState['availableProperties'][number];

interface ColorOptionProps {
  item: ColorOptionItem;
  allItems: Array<OptionVariationData>;
}

const Option = observer(({ item, allItems }: ColorOptionProps) => {
  const availableResultsCount = item.countAvailableResults(allItems);
  const disabled = availableResultsCount === 0;

  return (
    <label className={classNames(css.item, { [css.disabled]: disabled })}>
      <div className={css.color}>
        <div className={css.colorInner} style={{ backgroundColor: item.data.hexColor }} />
      </div>
      <div className={css.name}>
        {item.data.value} <span className={css.count}>({availableResultsCount})</span>
      </div>
      <input
        type="checkbox"
        className={css.input}
        checked={item.selected}
        name={item.data.name}
        value={item.data.value}
        disabled={disabled}
        onChange={() => item.toggle()}
      />
      <Icon className={classNames(css.check, { [css.visible]: item.selected })} name="check" />
    </label>
  );
});
